import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, onBeforeUnmount, provide } from "vue";
import type { PageBlock } from "@/views/blocks/PageBlock.interface";
import { randomId } from "@/shared/utils/helpers";
import type { ScrollAnimationType } from "@/apps/page/page-project.interface";


export default /*@__PURE__*/_defineComponent({
  __name: 'ComponentThumbnail',
  props: {
    block: {
        type: Object,
        required: true,
    },
    pageColors: {
        type: Object,
        required: true,
    },
    pageColorsStyles: {
        type: Object,
        required: true,
    },
    scrollAnimationType: {
        type: String as () => ScrollAnimationType,
        default: "fadeInSlideUp",
    },
},
  setup(__props) {

const props = __props;

provide("isMinimap", false);
provide("isPreview", false);

const previewRef = ref<HTMLElement | null>(null);
const containerRef = ref<HTMLElement | null>(null);
const scale = ref<number | null>(null);

function calculateScale() {
    const previewEl = previewRef.value;
    const containerEl = containerRef.value;

    if (!previewEl || !containerEl) return;

    const previewWidth = 271;
    const desktopWidth = 1800;
    const newScale = previewWidth / desktopWidth;
    scale.value = newScale;

    setTimeout(() => {
        const actualHeight = containerEl.scrollHeight;
        if (actualHeight > 0) {
            previewEl.style.height = `${actualHeight * (scale.value ?? 1)}px`;
        }
    });
}

function getPreviewProps() {
    const id = randomId();
    const webId = id.toString(24);

    return {
        block: {
            id,
            webId,
            dataValues: props.block.dataFields.reduce(
                (acc: Record<string, unknown>, field: any) => {
                    acc[field.value] = field.defaultData;
                    return acc;
                },
                {}
            ),
            styleValues: props.block.styleFields.reduce(
                (acc: Record<string, unknown>, field: any) => {
                    acc[field.value] = field.default;
                    return acc;
                },
                {}
            ),
        } satisfies PageBlock<any>,
        pageColors: props.pageColors,
        isPreview: false,
        scrollAnimationType: props.scrollAnimationType,
    };
}

onMounted(() => {
    calculateScale();
    window.addEventListener("resize", calculateScale);
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", calculateScale);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "previewRef",
    ref: previewRef,
    class: "w-full overflow-hidden border border-gray-300 rounded-xl relative"
  }, [
    _createElementVNode("div", {
      ref_key: "containerRef",
      ref: containerRef,
      class: "w-[1800px] will-change-transform",
      style: _normalizeStyle({
                transform: scale.value ? `scale(${scale.value})` : undefined,
                transformOrigin: 'top left',
                ...__props.pageColorsStyles,
            })
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(__props.block.component), _mergeProps(getPreviewProps(), { class: "pointer-events-none" }), null, 16))
    ], 4)
  ], 512))
}
}

})